const collectionActionPrefix = "ACTION_COLLECTION_";
const collectionMenuItemIdPrefix = "COLLECTION_";

export const getCollectionAction = (id: string) => `${collectionActionPrefix}${id}`;
export const isCollectionAction = (value: string) => value.startsWith(collectionActionPrefix);

export const getCollectionMenuItemId = (collectionId: string) => `${collectionMenuItemIdPrefix}${collectionId}`;
